// @flow

import React from 'react';

import styles from './styles.module.scss';

type Props = {
  text: string,
};

const Description = ({ text }: Props) => (
  <div className={styles.labelContainer}>
    <p className={styles.label}>{text} </p>
  </div>
);

export default Description;
